import React, {useEffect} from 'react'
import heroimg from '../../assets/Images/hero-img.png'
import playstore from '../../assets/Images/social/google-play-badge-logo-svgrepo-com.svg'

import 'aos/dist/aos.css'; 
import AOS from 'aos';



export default function Hero() {

    useEffect(() => {
        AOS.init({
          delay: 200
        });
      }, []); 

  return (
    <>
        <section id="hero" className="d-flex align-items-center">

        <div className="container">
        <div className="row">
            <div className="col-lg-6 d-lg-flex flex-lg-column justify-content-center align-items-stretch pt-5 pt-lg-0 order-2 order-lg-1" data-aos="fade-up">
            <div>
                <h1>We Learn, We Excel</h1>
                <h2>Dive into WeLearn, where each lesson is a steppingstone to
                  greatness. Explore with us, as learning guides the way to
                  success. Your journey to excellence starts here. </h2>
                <a href="" alt="Playstore" className="download-btn mb-3"><img src={playstore} alt="" /></a>
            </div>
            </div>
            <div className="col-lg-6 d-lg-flex flex-lg-column align-items-stretch order-1 order-lg-2 hero-img" data-aos="fade-up">
            <img src={heroimg} className="img-fluid" alt="" />
            </div>
        </div>
        </div>

        </section>
    </>
  )
}
